import React, {useState, useEffect, useMemo} from 'react'
import {
    Box,
    Heading,
    Image,
    useDisclosure
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import useCustomFetch from '../../../../hooks/useFetchContent'
import {brandHeroStyle} from './index.style'

function BrandHero({category}) {
    const {token} = useAccessToken()
    const {response} = useCustomFetch(token, [
        `dynamiccategorylanding-hero:category:${category?.id}`
    ])

    return <Box dangerouslySetInnerHTML={{__html: response}} sx={brandHeroStyle} />
}

BrandHero.propTypes = {
    category: PropTypes.object
}

export default BrandHero
